import classNames from "../../../utils/classNames"

export const TextInput = ({
  label,
  register,
  registerName,
  disabled = false,
  type = "text",
  placeholder = "",
  richText = false,
  cols = "sm:col-span-1",
  customClasses = "",
  rows = 2,
  initialValue = "",
  maxLength = 524288,
  required = false,
  size = "md",
  rounded = false,
  step = "",
  onBlur = (e) => {}
}) => {

  const sizeClasses = {
    sm: "px-2 py-1 text-sm",
    md: "px-3 py-2 text-sm",
    lg: "px-4 py-3 text-base"
  }

  const registerProps = register(registerName)

  // Keep react-hook-form's own blur handling when a custom one is passed in
  const handleBlur = (e) => {
    registerProps.onBlur?.(e)
    onBlur?.(e)
  }

  return (
    <div className={cols}>
      <label className="text-sm font-medium text-gray-500">
        {label}{required && <span className="text-primary-500">*</span>}
      </label>
      {
        richText ?
          <textarea
            {...registerProps}
            onBlur={handleBlur}
            disabled={disabled}
            className={classNames(
              disabled ? "bg-gray-300" : "", 
              `w-full mt-1 text-gray-900 border-1 border-gray-300 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 ${sizeClasses[size]} ${rounded ? "rounded-md" : ""} ${customClasses}`
            )}
            rows={rows}
            defaultValue={initialValue}
            maxLength={maxLength}
            required={required}
          />
          :
          <input
            {...registerProps}
            onBlur={handleBlur}
            disabled={disabled}
            type={type}
            {...(step && { step })}
            placeholder={placeholder}
            className={classNames(
              disabled ? "bg-gray-300" : "", 
              `w-full mt-1 text-gray-900 border-1 border-gray-300 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 ${sizeClasses[size]} ${rounded ? "rounded-md" : ""} ${customClasses}`
            )}
            defaultValue={initialValue}
            maxLength={maxLength}
            required={required}
          />
      }
    </div>
  )
}